import PasswordConfirmation from "@Modals/ConfirmPassword.vue";
import showModal from "@Helpers/functions/showModal";

export default function confirmPassword() {
  return new Promise((resolve) => {
    showModal(
      PasswordConfirmation,
      {},
      {},
      {
        closed: () => {
          if (localStorage.getItem("passwordConfirmed") === "true") {
            resolve(true);
          } else {
            resolve(false);
          }
        },
      },
    );
  });
}
